import tw from 'twin.macro'
import React, { useContext } from 'react'
import { PaymentsTableContext } from '../payments-table/PaymentsTable.context'
import { PaymentStatusSelect } from './PaymentStatusSelect'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { PaymentsBatchActionButton } from './action/PaymentsBatchActionButton'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission } from 'src/constants/user'
import { GridColumnsSelect } from 'src/components/shared/grid/grid-columns-select/GridColumnsSelect'

export const PaymentsHeader = () => {
  const {
    setSearchQuery,
    searchQuery,
    columnsConfig,
    columnVisibilityModel,
    pinnedColumns,
    lockedColumns,
    onToggleColumnVisibility,
    onColumnVisibilityModelChange,
    onPinColumn,
    onUnpinColumn,
  } = useContext(PaymentsTableContext)

  const { hasPermission } = useCheckPermissions()

  return (
    <div
      css={tw`flex flex-row items-center gap-4 px-4 py-3 bg-white rounded-t-lg border-0 border-b border-solid border-[#EDEDED]`}
    >
      {columnsConfig.length > 0 && (
        <GridColumnsSelect
          columnsConfig={columnsConfig}
          columnVisibilityModel={columnVisibilityModel}
          pinnedColumns={pinnedColumns}
          lockedColumns={lockedColumns}
          onToggleColumnVisibility={onToggleColumnVisibility}
          onColumnVisibilityModelChange={onColumnVisibilityModelChange}
          onPinColumn={onPinColumn}
          onUnpinColumn={onUnpinColumn}
        />
      )}
      <TableSearch
        searchQuery={searchQuery}
        onChangeSearchQuery={setSearchQuery}
        inputDataTestId="payments-main-search-input"
        clearButtonDataTestId="payments-main-search-clear-btn"
      />
      <PaymentStatusSelect />
      {hasPermission(UserPermission.PaymentsDelete) && <PaymentsBatchActionButton />}
    </div>
  )
}
